import { render, staticRenderFns } from "./ApproveDialog.vue?vue&type=template&id=f068bae4&scoped=true"
import script from "./ApproveDialog.vue?vue&type=script&lang=ts"
export * from "./ApproveDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f068bae4",
  null
  
)

export default component.exports